import { images, mainImages } from "@/utils/images";

import CustomImage from "@/components/CustomImage";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { useTranslation } from "@/hooks/useTranslation";

export default function HeroSection() {
  const { t } = useTranslation();
  return (
    <>
      <motion.div 
        className="relative px-4 py-4 mb-10 max-w-5xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="relative isolate z-0 mb-14">
          <h1 className="text-slate-900 font-extrabold text-3xl md:text-5xl !leading-normal text-center dark:text-white">
            {t('hero_title_part1')}
            <motion.div
              className="inline-block px-2.5 py-1 ml-4 mr-2.5 rounded-2xl bg-gray-100 text-gray-950"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              {t('hero_title_highlight')}</motion.div>
            {t('hero_title_part2')}
          </h1>
          <p className="flex flex-wrap gap-1 justify-center mt-6 text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto dark:text-slate-400">
            <code className="font-semibold text-gray-600">
            {t('hero_subtitle_highlight')}
            </code>
            {t('hero_subtitle')}
          </p>
        </div>
      </motion.div>
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <Marquee pauseOnHover autoFill speed={120}>
          <div className="flex h-fit">
            {mainImages.map((img, index) => 
              <div key={index} className={`relative overflow-hidden rounded-3xl w-[270px] h-[180px] md:w-[420px] md:h-[320px] mr-2`}>
                <CustomImage
                  fill
                  src={img}
                  className="transition duration-500 object-cover"
                  alt={'main-image'}
                />
              </div>
            )}
          </div>
        </Marquee>
      </motion.div>
    </>
  )
} 